// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  register: path(ROOTS_AUTH, "/register"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  forgetPassword: path(ROOTS_AUTH, "/forget-password"),
  verify: path(ROOTS_AUTH, "/verify"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  redirect: "/",
  payment: {
    root: path(ROOTS_DASHBOARD, "/financial/payments"),
    view: (id) => path(ROOTS_DASHBOARD, `/financial/payments/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/financial/payments/${id}/edit`),
  },
  order: {
    root: path(ROOTS_DASHBOARD, "/orders"),
    status: (slug) => path(ROOTS_DASHBOARD, `/orders/${slug}`),
  },
  category: {
    root: path(ROOTS_DASHBOARD, `/categories`),
    view: (slug) => path(ROOTS_DASHBOARD, `/categories/${slug}`),
  },
  service: {
    root: path(ROOTS_DASHBOARD, `/services`),
    view: (slug) => path(ROOTS_DASHBOARD, `/services/${slug}`),
    order: (slug) => path(ROOTS_DASHBOARD, `/services/${slug}/order`),
  },
  account: {
    root: path(ROOTS_DASHBOARD, `/account`),
  },
};
